import React, { useEffect, useRef, useState } from "react";
import ImageUpload from "../ImageUpload";
import ImageUploadSplitCanvas from "./ImageUploadSplitCanvas";
import html2canvas from "html2canvas";
import { toastEmmit } from "../../../../Helper/Toastr";

const Block1 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
  selectedSize,
}) => {
  const [selectedImages, setSelectedImages] = useState("");
  const [BlobImage, setBlobImage] = useState("");

  useEffect(() => {
    if (addToCartTriggered) {
      capture();
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    console.log(selectedImages);
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      // setFullImageDataURL(imageDataUrl);
    });
  };

  // ==================================================================================================

  const [imageParts, setImageParts] = useState([]);
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  // Function to handle image selection and splitting
  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg+xml"];
      if (!validImageTypes.includes(file.type)) {
        toastEmmit("error","Please upload a valid image");
        return;
      }
    }
    setimageloading(true);
    const reader = new FileReader();

    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const partWidth = image.width / 3;
        const partHeight = image.height;

        canvas.width = partWidth;
        canvas.height = partHeight;

        const parts = [];

        for (let i = 0; i < 3; i++) {
          ctx.drawImage(
            image,
            i * partWidth,
            0,
            partWidth,
            partHeight,
            0,
            0,
            partWidth,
            partHeight
          );
          parts.push(canvas.toDataURL());
        }

        setImageParts(parts);
      };
    };

    if (file) {
      reader.readAsDataURL(file);
    }
    setSelectedImages([file]);
  };

  const [imageloading, setimageloading] = useState(false);

  const handleImageLoad = () => {
    setimageloading(false);
  };

  return (
    <>
      <div className="large-bg collage-36 images-12-12 sp-c-1">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>
                {selectedSize?.id === 32
                  ? '36"'
                  : selectedSize?.id === 33
                  ? '32"'
                  : selectedSize?.id === 34
                  ? '40"'
                  : selectedSize?.id === 35
                  ? '48"'
                  : selectedSize?.id === 36
                  ? '60"'
                  : ""}
              </span> */}
            </div>
            <div className="d-flex" id="captureArea">
              <div class="frame-left">
                <div className="control-group file-upload">
                  <div className="image-box">
                    {imageloading && (
                      <div
                        className={`align-items-center d-flex justify-content-center ${selectedSize?.id === 32
                          ? "s-3-12x36-panels last-seven-collage"
                          : selectedSize?.id === 33
                          ? "s-3-16x42-panels last-seven-collage"
                          : selectedSize?.id === 34
                          ? "s-3-18x40-panels last-seven-collage"
                          : selectedSize?.id === 35
                          ? "s-3-20x48-panels last-seven-collage"
                          : selectedSize?.id === 36
                          ? "s-3-24x60-panels last-seven-collage"
                          : "s-3-12x36-panels last-seven-collage"}`}
                      >
                        <i
                          className="fa fa-spinner fa-pulse fa-2x fa-fw"
                          style={{ animationDuration: "1.5s" }}
                        ></i>
                      </div>
                    )}

                    {
                      <img
                        src={
                          imageParts[0] ||
                          (selectedSize?.id === 32
                            ? "assets/img/breadcrumb/s-3-12x36-panels-plane.svg"
                            : selectedSize?.id === 33
                            ? "assets/img/breadcrumb/s-3-16x42-panels-plane.svg"
                            : selectedSize?.id === 34
                            ? "assets/img/breadcrumb/s-3-18x40-panels-plane.svg"
                            : selectedSize?.id === 35
                            ? "assets/img/breadcrumb/s-3-20x48-panels-plane.svg"
                            : selectedSize?.id === 36
                            ? "assets/img/breadcrumb/s-3-24x60-panels-plane.svg"
                            : "assets/img/blog/thumb.png")
                        }
                        alt="Part 1"
                        onClick={handleImageClick}
                        className={
                          selectedSize?.id === 32
                            ? "s-3-12x36-panels last-seven-collage"
                            : selectedSize?.id === 33
                            ? "s-3-16x42-panels last-seven-collage"
                            : selectedSize?.id === 34
                            ? "s-3-18x40-panels last-seven-collage"
                            : selectedSize?.id === 35
                            ? "s-3-20x48-panels last-seven-collage"
                            : selectedSize?.id === 36
                            ? "s-3-24x60-panels last-seven-collage"
                            : "s-3-12x36-panels last-seven-collage"
                        }
                        onLoad={handleImageLoad}
                        style={{display: imageloading ? "none" : "block"}}
                      />
                    }
                  </div>
                  <div className="controls" style={{ display: "none" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageSelect}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
              <div class="frame-left">
                <div className="control-group file-upload">
                  <div className="image-box">
                  {imageloading && (
                      <div
                        className={`align-items-center d-flex justify-content-center ${selectedSize?.id === 32
                          ? "s-3-12x36-panels last-seven-collage"
                          : selectedSize?.id === 33
                          ? "s-3-16x42-panels last-seven-collage"
                          : selectedSize?.id === 34
                          ? "s-3-18x40-panels last-seven-collage"
                          : selectedSize?.id === 35
                          ? "s-3-20x48-panels last-seven-collage"
                          : selectedSize?.id === 36
                          ? "s-3-24x60-panels last-seven-collage"
                          : "s-3-12x36-panels last-seven-collage"}`}
                      >
                        <i
                          className="fa fa-spinner fa-pulse fa-2x fa-fw"
                          style={{ animationDuration: "1.5s" }}
                        ></i>
                      </div>
                    )}
                    {
                      <img
                        src={
                          imageParts[1] ||
                          (selectedSize?.id === 32
                            ? "assets/img/breadcrumb/s-3-12x36-panels.svg"
                            : selectedSize?.id === 33
                            ? "assets/img/breadcrumb/s-3-16x42-panels.svg"
                            : selectedSize?.id === 34
                            ? "assets/img/breadcrumb/s-3-18x40-panels.svg"
                            : selectedSize?.id === 35
                            ? "assets/img/breadcrumb/s-3-20x48-panels.svg"
                            : selectedSize?.id === 36
                            ? "assets/img/breadcrumb/s-3-24x60-panels.svg"
                            : "assets/img/blog/thumb.png")
                        }
                        alt="Part 2"
                        onClick={handleImageClick}
                        className={
                          selectedSize?.id === 32
                            ? "s-3-12x36-panels last-seven-collage"
                            : selectedSize?.id === 33
                            ? "s-3-16x42-panels last-seven-collage"
                            : selectedSize?.id === 34
                            ? "s-3-18x40-panels last-seven-collage"
                            : selectedSize?.id === 35
                            ? "s-3-20x48-panels last-seven-collage"
                            : selectedSize?.id === 36
                            ? "s-3-24x60-panels last-seven-collage"
                            : "s-3-12x36-panels last-seven-collage"
                        }
                        onLoad={handleImageLoad}
                        style={{display: imageloading ? "none" : "block"}}
                      />
                    }
                  </div>
                  <div className="controls" style={{ display: "none" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageSelect}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
              <div class="frame-left">
                <div className="control-group file-upload">
                  <div className="image-box">
                  {imageloading && (
                      <div
                        className={`align-items-center d-flex justify-content-center ${selectedSize?.id === 32
                          ? "s-3-12x36-panels last-seven-collage"
                          : selectedSize?.id === 33
                          ? "s-3-16x42-panels last-seven-collage"
                          : selectedSize?.id === 34
                          ? "s-3-18x40-panels last-seven-collage"
                          : selectedSize?.id === 35
                          ? "s-3-20x48-panels last-seven-collage"
                          : selectedSize?.id === 36
                          ? "s-3-24x60-panels last-seven-collage"
                          : "s-3-12x36-panels last-seven-collage"}`}
                      >
                        <i
                          className="fa fa-spinner fa-pulse fa-2x fa-fw"
                          style={{ animationDuration: "1.5s" }}
                        ></i>
                      </div>
                    )}
                    {
                      <img
                        src={
                          imageParts[2] ||
                          (selectedSize?.id === 32
                            ? "assets/img/breadcrumb/s-3-12x36-panels-plane.svg"
                            : selectedSize?.id === 33
                            ? "assets/img/breadcrumb/s-3-16x42-panels-plane.svg"
                            : selectedSize?.id === 34
                            ? "assets/img/breadcrumb/s-3-18x40-panels-plane.svg"
                            : selectedSize?.id === 35
                            ? "assets/img/breadcrumb/s-3-20x48-panels-plane.svg"
                            : selectedSize?.id === 36
                            ? "assets/img/breadcrumb/s-3-24x60-panels-plane.svg"
                            : "assets/img/blog/thumb.png")
                        }
                        alt="Part 3"
                        onClick={handleImageClick}
                        className={
                          selectedSize?.id === 32
                            ? "s-3-12x36-panels last-seven-collage"
                            : selectedSize?.id === 33
                            ? "s-3-16x42-panels last-seven-collage"
                            : selectedSize?.id === 34
                            ? "s-3-18x40-panels last-seven-collage"
                            : selectedSize?.id === 35
                            ? "s-3-20x48-panels last-seven-collage"
                            : selectedSize?.id === 36
                            ? "s-3-24x60-panels last-seven-collage"
                            : "s-3-12x36-panels last-seven-collage"
                        }
                        onLoad={handleImageLoad}
                        style={{display: imageloading ? "none" : "block"}}
                      />
                    }
                  </div>
                  <div className="controls" style={{ display: "none" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageSelect}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>
              {selectedSize?.id === 32
                ? '36"'
                : selectedSize?.id === 33
                ? '48"'
                : selectedSize?.id === 34
                ? '54"'
                : selectedSize?.id === 35
                ? '60"'
                : selectedSize?.id === 36
                ? '72"'
                : ""}
            </span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Block2 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
  selectedSize,
}) => {
  const [selectedImages, setSelectedImages] = useState("");
  const [BlobImage, setBlobImage] = useState("");

  useEffect(() => {
    if (addToCartTriggered) {
      capture();
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    console.log(selectedImages);
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const capture = () => {
    const captureArea = document.getElementById("captureArea");
    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      // setFullImageDataURL(imageDataUrl);
    });
  };

  // ==================================================================================================

  const [imageParts, setImageParts] = useState([]);
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  // Function to handle image selection and splitting
  const handleImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg+xml"];
      if (!validImageTypes.includes(file.type)) {
        toastEmmit("error","Please upload a valid image");
        return;
      }
    }
    setimageloading(true);
    const reader = new FileReader();

    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const partWidth = image.width / 2;
        const partHeight = image.height;

        canvas.width = partWidth;
        canvas.height = partHeight;

        const parts = [];

        for (let i = 0; i < 2; i++) {
          ctx.drawImage(
            image,
            i * partWidth,
            0,
            partWidth,
            partHeight,
            0,
            0,
            partWidth,
            partHeight
          );
          parts.push(canvas.toDataURL());
        }

        setImageParts(parts);
      };
    };

    if (file) {
      reader.readAsDataURL(file);
    }
    setSelectedImages([file]);
  };

  const [imageloading, setimageloading] = useState(false);

  const handleImageLoad = () => {
    setimageloading(false);
  };

  return (
    <>
      <div className="large-bg collage-35 images-12-12 sp-c-1">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
            <div className="number-line">
              {/* <span>
                {selectedSize?.id === 27
                  ? '24"'
                  : selectedSize?.id === 28
                  ? '30"'
                  : selectedSize?.id === 29
                  ? '36"'
                  : selectedSize?.id === 30
                  ? '40"'
                  : selectedSize?.id === 31
                  ? '90"'
                  : ""}
              </span> */}
            </div>
            <div className="d-flex" id="captureArea">
              <div class="frame-left">
                <div className="control-group file-upload">
                  <div className="image-box">
                  {imageloading && (
                      <div
                        className={`align-items-center d-flex justify-content-center ${ selectedSize?.id === 27
                          ? "s-2-18x24-panels last-seven-collage"
                          : selectedSize?.id === 28
                          ? "s-2-23x30-panels last-seven-collage"
                          : selectedSize?.id === 29
                          ? "s-2-27x36-panels last-seven-collage"
                          : selectedSize?.id === 30
                          ? "s-2-30x40-panels last-seven-collage"
                          : selectedSize?.id === 31
                          ? "s-2-30x60-panels last-seven-collage"
                          : "s-2-18x24-panels last-seven-collage"}`}
                      >
                        <i
                          className="fa fa-spinner fa-pulse fa-2x fa-fw"
                          style={{ animationDuration: "1.5s" }}
                        ></i>
                      </div>
                    )}
                    {
                      <img
                        src={
                          imageParts[0] ||
                          (selectedSize?.id === 27
                            ? "assets/img/breadcrumb/s-2-18x24-panels.svg"
                            : selectedSize?.id === 28
                            ? "assets/img/breadcrumb/s-2-23x30-panels.svg"
                            : selectedSize?.id === 29
                            ? "assets/img/breadcrumb/s-2-27x36-panels.svg"
                            : selectedSize?.id === 30
                            ? "assets/img/breadcrumb/s-2-30x40-panels.svg"
                            : selectedSize?.id === 31
                            ? "assets/img/breadcrumb/s-2-30x60-panels.svg"
                            : "assets/img/blog/thumb.png")
                        }
                        alt="Part 1"
                        onClick={handleImageClick}
                        className={
                          selectedSize?.id === 27
                            ? "s-2-18x24-panels last-seven-collage"
                            : selectedSize?.id === 28
                            ? "s-2-23x30-panels last-seven-collage"
                            : selectedSize?.id === 29
                            ? "s-2-27x36-panels last-seven-collage"
                            : selectedSize?.id === 30
                            ? "s-2-30x40-panels last-seven-collage"
                            : selectedSize?.id === 31
                            ? "s-2-30x60-panels last-seven-collage"
                            : "s-2-18x24-panels last-seven-collage"
                        }
                        onLoad={handleImageLoad}
                        style={{display: imageloading ? "none" : "block"}}
                      />
                    }
                  </div>
                  <div className="controls" style={{ display: "none" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageSelect}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>

              <div class="frame-left">
                <div className="control-group file-upload">
                  <div className="image-box">
                  {imageloading && (
                      <div
                        className={`align-items-center d-flex justify-content-center ${selectedSize?.id === 27
                          ? "s-2-18x24-panels last-seven-collage"
                          : selectedSize?.id === 28
                          ? "s-2-23x30-panels last-seven-collage"
                          : selectedSize?.id === 29
                          ? "s-2-27x36-panels last-seven-collage"
                          : selectedSize?.id === 30
                          ? "s-2-30x40-panels last-seven-collage"
                          : selectedSize?.id === 31
                          ? "s-2-30x60-panels last-seven-collage"
                          : "s-2-18x24-panels last-seven-collage"}`}
                      >
                        <i
                          className="fa fa-spinner fa-pulse fa-2x fa-fw"
                          style={{ animationDuration: "1.5s" }}
                        ></i>
                      </div>
                    )}
                    {
                      <img
                        src={
                          imageParts[1] ||
                          (selectedSize?.id === 27
                            ? "assets/img/breadcrumb/s-2-18x24-panels-plane.svg"
                            : selectedSize?.id === 28
                            ? "assets/img/breadcrumb/s-2-23x30-panels-plane.svg"
                            : selectedSize?.id === 29
                            ? "assets/img/breadcrumb/s-2-27x36-panels-plane.svg"
                            : selectedSize?.id === 30
                            ? "assets/img/breadcrumb/s-2-30x40-panels-plane.svg"
                            : selectedSize?.id === 31
                            ? "assets/img/breadcrumb/s-2-30x60-panels-plane.svg"
                            : "assets/img/blog/thumb.png")
                        }
                        alt="Part 2"
                        onClick={handleImageClick}
                        className={
                          selectedSize?.id === 27
                            ? "s-2-18x24-panels last-seven-collage"
                            : selectedSize?.id === 28
                            ? "s-2-23x30-panels last-seven-collage"
                            : selectedSize?.id === 29
                            ? "s-2-27x36-panels last-seven-collage"
                            : selectedSize?.id === 30
                            ? "s-2-30x40-panels last-seven-collage"
                            : selectedSize?.id === 31
                            ? "s-2-30x60-panels last-seven-collage"
                            : "s-2-18x24-panels last-seven-collage"
                        }
                        onLoad={handleImageLoad}
                        style={{display: imageloading ? "none" : "block"}}
                      />
                    }
                  </div>
                  <div className="controls" style={{ display: "none" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageSelect}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="number-line-2">
            {/* <span>
              {selectedSize?.id === 27
                ? '36"'
                : selectedSize?.id === 28
                ? '46"'
                : selectedSize?.id === 29
                ? '54"'
                : selectedSize?.id === 30
                ? '60"'
                : selectedSize?.id === 31
                ? '60"'
                : ""}
            </span> */}
          </div>
        </div>
      </div>
    </>
  );
};

const Default = () => {
  return (
    <div className="frame-container">
      <img
        src="assets/img/blog/thumb.png"
        alt=""
        style={{ objectFit: "contain", maxWidth: "100%" }}
      />
    </div>
  );
};

export default function CustomBlocksSplitCanvas({
  selectedSize,
  addToCartTriggered,
  sendAllSelectedImages,
  sendblobImage,
}) {
  const updateAllSelectedImages = (images) => {
    console.log(images);
    sendAllSelectedImages(images);
  };

  const SendBlobImage = (images) => {
    sendblobImage(images);
  };

  return (
    <>
      {selectedSize?.id === 32 ||
      selectedSize?.id === 33 ||
      selectedSize?.id === 34 ||
      selectedSize?.id === 35 ||
      selectedSize?.id === 36 ? (
        <Block1
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
          selectedSize={selectedSize}
        />
      ) : selectedSize?.id === 27 ||
        selectedSize?.id === 28 ||
        selectedSize?.id === 29 ||
        selectedSize?.id === 30 ||
        selectedSize?.id === 31 ? (
        <Block2
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
          selectedSize={selectedSize}
        />
      ) : (
        <Default />
      )}
    </>
  );
}
